import React from 'react';

interface StarRatingTooltipProps {
    id: string;
    children: React.ReactNode;
}

/**
 * Tooltip shown above a hovered or focused star. Styled to match SWAN's
 * IconButton tooltip using the same component tokens.
 *
 * Internal to StarRating — not exported from the lib.
 */
export const StarRatingTooltip = ({ id, children }: StarRatingTooltipProps) => (
    <span
        id={id}
        role="tooltip"
        style={{
            position: 'absolute',
            bottom: 'calc(100% + 8px)',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 'var(--swan-sem-z-index-floating)',
            maxWidth: 'var(--swan-comp-icon-button-tooltip-max-width)',
            padding: 'var(--swan-sem-space-1) var(--swan-sem-space-3)',
            borderRadius: 'var(--swan-sem-border-radius-subtle)',
            background: 'var(--swan-sem-color-bg-info-strong-paired)',
            color: 'var(--swan-sem-color-text-info-strong-paired)',
            filter: 'drop-shadow(var(--swan-sem-elevation-floating))',
            fontFamily: 'var(--swan-base-font-family-primary)',
            fontSize: 'var(--swan-sem-font-size-xsmall)',
            fontWeight: 'var(--swan-base-font-weight-normal)',
            letterSpacing: 'var(--swan-base-font-letter-spacing-300)',
            lineHeight: 'var(--swan-base-font-line-height-500)',
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
        }}
    >
        {children}
    </span>
);
